module.exports = __webpack_public_path__ + "img/a62d275fda27ccbaa0d286874a11dd6f.png";